import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SessionStorageService } from '../shared/services/session-storage';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        language: 'Language:',
        'eng-lang-button': 'EN',
        'heb-lang-button': 'HEB',
        'e-mail': 'E-mail',
        'enter-ID-number': 'ID number',
        'enter-email-address': 'Email address',
        password: 'Password',
        'forgot-password': 'Forgot password?',
        'sign-in': 'Sign In',
        'otp-sign-in': 'Sign In With OTP',
        'email-sign-in': 'Sign In With Email And Password',
        'monthly-overview-upper-case': 'MY FILES',
        'all-files-upper-case': 'ALL FILES',
        'all-files': 'All Files',
        'employees': 'Employees',
        files: 'Files',
        invoices: 'Invoices',
        expenses: 'Expenses',
        salaries: 'Reports and Salaries',
        payslip: 'Salaries',
        'document-not-available': 'The document is not available',
        'try-again-later': 'Please try again later',
        'profile-info': 'My Profile',
        name: 'Name',
        phone: 'Phone',
        'created-date': 'Created Date',
        type: 'Type',
        customer: 'Customer',
        'total-nis': 'Total (Nis)',
        'total-paid': 'Total Paid:',
        'total-estimation': 'Total Estimation:',
        nis: 'NIS',
        'salaries-subtitle': 'The monthly summary and the payslip will be updated every month on the 15th.',
        'my-salary': 'Salary',
        'monthly-overview': 'My files',
        invoice: 'Invoice',
        receipt: 'Receipt',
        'invoice/receipt': 'Invoice/Receipt',
        'invoice-c': 'Invoice-c',
        back: 'Back',
        'company-name': 'Company name',
        'street-address': 'Street Address',
        city: 'City',
        'email-address': 'Email Address',
        'phone-number': 'Phone: (000) 000-00-00',
        'invoice-number': 'Invoice #',
        'bill-to': 'Bill To:',
        description: 'Description',
        'service-fee': 'Service Fee',
        labor: 'Labor:',
        'hours-at': 'hours at',
        hr: 'hr',
        'new-client-discount': 'New Client Discount',
        tax: 'Tax: 4.25% (after discount)',
        thanks: 'Thank you for your business!',
        total: 'Total',
        'auth-error': 'Wrong e-mail or password.',
        'identity-number': 'Personal ID',
        'dont-have-account': 'Don’t have an account?',
        'already-have-account': 'Already have an account?',
        'contact-with-us': 'Contact us',
        'sign-up': 'Sign Up',
        'otp-sign-up': 'Sign Up With OTP',
        'email-sign-up': 'Sign Up With Email And Password',
        'or-string': 'OR',
        'one-time-code': "Code",
        'get-one-time-password': 'Get One Time Password',
        'send-password-again': `Didn't receive a password? Send password again.`,
        'got-password': "A password has been sent to your email address.",
        'verify-and-login': 'Verify and login',
        'verification-code': 'Verification code',
        'code-sent-to': 'Enter the code sent to the address',
        'send-new-code': 'Resend code',
        'fill-all-fields': 'Please fill in all fields',
        'invalid-email': 'Invalid email address',
        'invalid-id-number': 'ID number must contain at least 7 digits',
        'invalid-otp-code': 'Invalid verification code',
        'use-regular-password': 'Use Regular Password',
        'code': 'Code',
        'didnt-get-code': 'Didn\'t get the code?',
        'resend': 'Resend',
        job: 'Job',
        'update-details': 'Update details',
        'sign-out': 'Sign Out',
        'session-expired': 'Your session has expired. Please sign in again.',
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
        'part-number': 'Part Number',
        'unit-price': 'Unit Price',
        'total-price': 'Total Price',
        qty: 'Qty',
        'sub-total': 'Sub Total',
        discount: 'Discount',
        vat: 'Vat of 17%',
        number: 'Number',
        'company-general-title':
          'Yeul Sachir Mechkar Upituach Ltd.- YS Research & Development Ltd.',
        'company-address':
          'Address: 16 King George St. 3rd Entrance, P.O.B 7992, Jerusalem 9107901,',
        'support-phone': '+972-2-6510666',
        'company-dealer': 'Licensed Dealer: 514129717',
        'invoice-note-row-1':
          'Please either send acheck to YEULS SACHIR RES AND DEV LTD P.O.B 7992 JERUSALEM 91079 OR',
        'invoice-note-row-2':
          'For that purpose, we have opened a local bank account in the USA.',
        'invoice-note-row-3':
          'Please use the bellow bank details for your future transfers.',
        'invoice-note-row-4':
          'For local ACH transfer: Bank Name First Century Bank routing (ABA)061120084 Account Number 4024140610925.',
        'invoice-note-row-5':
          'Account Type CHECKING Beneficiary Name YEUL SACHIR RES AND DEV LTD.',
        'invoice-note-row-6':
          'For swift transfer: Bank Name: Metropolitan Commercial Bank.',
        'invoice-note-row-7':
          'Bank address 99 Park Avenue 4th Floor, New York, NY 10016 Fedwire ABA number 026013356.',
        'invoice-note-row-8':
          'Account Number 8799004505 Beneficiary Name YEUL SACHIR RES AND DEV LTD.',
        'home-page-title': 'Welcome to Yeul Sachir',
        'home-page': 'Home Page',
        'project-management': 'Project Management',
        'general-docs': 'General documents',
        'general-docs-subtitle': 'Here you can view and download your personal work documents, employment contracts, and tax forms.',
        'contact-us-title': 'Contact Us',
        'general-manager': 'Rodan- General Manager',
        'contact-info': 'Contact Info',
        'office-manager': 'Rima- Office Manager. Salaries, Banking',
        'payroll-accounting': 'Ora - Payroll Accounting',
        billing: 'Oshrat- Billing, Expenses, Collection',
        'accounting-manager': 'Oshrat- Billing, Expenses, Collection',
        'savings-pension': 'Daniel - Business Development',
        'operations-manager': 'Natalie-  Operations Manager',
        'yeul-sachir-title': 'Yeul Sachir',
        'mailing-address-title': 'Mailing Address:',
        'mailing-address': 'POB 7992 Jerusalem Israel 9107901',
        'office-address-title': 'Office Address:',
        'office-address':
          '16 King George Street, Entrance C, 10th Floor, Jerusalem, Israel',
        telephone: 'Telephone:',
        fax: 'Fax:',
        'bank-info-title': 'Bank Information:',
        'bank-title-1': 'Yeul Sachir Mechkar UPituach Ltd',
        'bank-mizrachi-tefachot': 'Bank Mizrachi Tefachot',
        'bank-number-20': 'Bank #20',
        'bank-brach-number': 'Talpiot Branch 517',
        'bank-account-number-1': 'Account #188832',
        'bank-title-2': 'Yeul Sachir',
        'bank-account-number-2': 'Account #103888',
        'mail-info-title': 'Mail Information:',
        'monthly-summary': 'Monthly Summary',
        'us-bank-details': 'U.S bank details',
        'no-files': 'No Files',
        'search-by-user-id': 'Search by user id',
        search: 'Search',
        'search-by-invoice-number': 'Search by invoice number',
        'search-by-receipt-number': 'Search by receipt number',
        'general-search': 'Search...',
        'search-helper-text':
          '*search by user identity number to view his files',
        'not-complite-registration': 'User didn’t complete his registration',
        'send-instructions': 'Send Instructions',
        'reset-password': 'Reset password',
        'reset-password-text':
          "Enter the email associated with your account and we'll send an email with instructions to reset your password",
        'check-your-email-instructions':
          'We have sent a password recover instructions to your email',
        'check-your-email': 'Check your mail',
        'check-spam': 'Did not receive the email? Check your spam filter, or',
        'try-another-email': 'try another email address',
        'create-password': 'Create password',
        'origin-amount': 'Total',
        rate: 'Rate',
        'currency-type': 'Currency',
        'monthly-files': 'Monthly Files',
        'upload-files': 'Upload Files',
        'drag-n-drop':
          "Drag 'n' drop some files here, or click to select files",
        'drag-n-drop-format': 'Files should be in the following format only:',
        'file-number': 'File number',
        'file-name': 'File name',
        'file-type': 'File type',
        user: 'User',
        'missed-files': 'Missed Files',
        'notes': 'Notes',
        'id': 'ID',
        'agent-id': 'Agent ID',
        'email': 'Email',
        'status': 'Status',
        'active': 'Active',
        'dismissed': 'Dismissed',
        'company-id': 'Company ID',
        'with-capital-employees': 'Accounts',
        'agents-list': 'Private Agents',
        'companies-list': 'Company Agents',
        'search-by-all-fields': 'Search by Employee Name, Company Name, ID, Agent ID, Email',
        'monthly-report': 'Monthly Report',
        'days': 'Days',
        'cost': 'Cost',
        'fee': 'Fee',
        'daily-rate-with-colon': 'Daily Rate:',
        'hourly-rate-with-colon': 'Hourly rate:',
        'daily-off-rate': 'Daily Off Rate:',
        'exchange-rate': 'Exchange Rate:',
        'total-cost-with-colon': 'Total cost:',
        'total-fee': 'Total fee:',
        'send-report': 'Send Report',
        'profile': 'Profile',
        'date': 'Date',
        'note': 'Note',
        'amount': 'Amount',
        'half-day-50': 'Half Day 50%',
        'transit-60': 'Transit 60%',
        'day-100': 'Day 100%',
        'day-off-150': 'Day Off 150%',
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'validate-and-approve': 'Validate & Approve',
        'open': 'Open',
        'closed': 'Closed',
        'ready': 'Ready',
        'in-progress': 'In progress',
        'admin-panel': 'Admin Panel',
        'firstname': 'Firstname',
        'lastname': 'Lastname',
        'create-user': 'Create user',
        'admin': 'Admin',
        'role': 'Role',
        'company': 'Company',
        'create-company': 'Create company',
        'is-use-daily-rate': 'Is use daily rate',
        'hourly-rate': 'Hourly rate',
        'daily-rate': 'Daily Rate',
        'employee': 'Employee',
        'manager': 'Manager',
        'create-company-user': 'Create company user',
        'done': 'Done',
        'pending': 'Pending',
        'hours': 'Hours',
        'currency': 'Currency',
        'include-vat-17': 'Include VAT (17%)',
        'create-invoice': 'Create invoice',
        'send-on-email': 'Send on Email?',
        'yes': 'Yes',
        'no': 'No',
        '1st': '1st',
        '9st': '9st',
        'total-income': 'Total income',
        'total-expense': 'Total expense',
        'amount-vat-17': 'Amount + VAT (17%)',
        'paid-by': 'Paid By',
        'total-income-with-colon': 'Total income:',
        'total-outcome-with-colon': 'Total outcome:',
        'add-income': 'Add Income',
        'split-income': 'Split Income',
        'split-outcome': 'Split outcome',
        'reset-salary': 'Reset Salary',
        'save-salary': 'Save Salary',
        'edit-user': 'Edit User',
        'actions': 'Actions',
        'update-user': 'Update User',
        'user-terms': 'User Terms',
        'yeuls-fee': 'Yeuls Fee (0-100%)',
        'salary-date': 'Salary Date',
        'calculation-type': 'Calculation Type',
        'max-yeuls-fee': 'Max Yeuls Fee',
        'first': '1th',
        'ninth': '9th',
        'gross': 'Gross',
        'edit-company': 'Edit Company',
        'update-company': 'Update Company',
        'company-terms': 'Company Terms',
        'update-company-user': 'Update Company User',
        'create-csv': 'Create Csv',
        'search-by-name-and-id': 'Search by Employee Name, Agent ID',
        'paid': 'Paid',
        'not-paid': 'Not Paid',
        'total-fee-cost': "Total fee cost",
        'total-cost': 'Total cost',
        'total-net': 'Total net',
        'export-to-csv': 'Export to CSV',
        'import-csv': 'Import CSV',
        'oketz-number': 'Oketz Number',
        'country': 'Country',
        'address': 'Address',
        'car-details': 'Car Details',
        'report-type': 'Report Type',
        'start-date': 'Start Date',
        'end-date': 'End Date',
        'bank-name': 'Bank Name',
        'bank-number': 'Bank Number',
        'bank-branch-number': 'Bank Branch Name',
        'bank-account-number': 'Bank Account Name',
        'insurance-notes': 'Insurance Notes',
        'next': 'Next',
        'hourly': 'Hourly',
        'daily': 'Daily',
        'fixed': 'Fixed',
        'general': 'General',
        'terms-and-conditions': 'Terms And Conditions',
        'bank': 'Bank',
        'insurance': 'Insurance',
        'edit': 'Edit',
        'save': 'Save',
        'santec-account-id': 'Santec Account Id',
        'default-daily-rate': 'Default Daily Rate',
        'companies': 'Companies',
        'user-companies-empty-list': 'User doesn\'t have companies!!!',
        'included-vat': 'Included Vat',
        'users': 'Users',
        'report-fee': 'Report fee',
        'heb': 'HEB',
        'eng': 'ENG',
        'USD': 'USD',
        'NIS': 'NIS',
        'EUR': 'EUR',
        'registration-fee': 'Registration Fee',
        'registration-fee-paid': 'Registration Fee Paid',
        'registration-fee-free': 'Registration Fee Free',
        'clients-list': 'Clients',
        'suppliers-list': 'Suppliers',
        'create-client': 'Create client',
        'create-supplier': 'Create supplier',
        'client-name': 'Client name',
        'business-number': 'Business number',
        'withholding-tax': 'Withholding tax',
        'withholding-tax-expiration': 'Withholding tax expiration',
        'general-ledger': 'General ledger',
        'zip': 'ZIP',
        'created-by': 'Created by',
        'agents-count': 'Agents count',
        'to-search-message': 'Please start typing to see the result',
        'client-companies-empty-list': 'Client doesn\'t have companies!!!',
        'client-users-empty-list': 'Client doesn\'t have users!!!',
        'supplier-companies-empty-list': 'Supplier doesn\'t have companies!!!',
        'supplier-users-empty-list': 'Supplier doesn\'t have users!!!',
        'supplier-name': 'Supplier name',
        'accounts': 'Accounts',
        'links': 'Links',
        'clients': 'Clients',
        'suppliers': 'Suppliers',
        'user-clients-empty-list': 'User doesn\'t have clients!!!',
        'user-suppliers-empty-list': 'User doesn\'t have suppliers!!!',
        'company-clients-empty-list': 'Company doesn\'t have clients!!!',
        'company-suppliers-empty-list': 'Company doesn\'t have suppliers!!!',
        'employees-list': 'Employees list',
        'user-updated': 'User updated!!!',
        'user-created': 'User created!!!',
        'company-updated': 'Company updated!!!',
        'company-created': 'Company created!!!',
        'client-updated': 'Client updated!!!',
        'client-created': 'Client created!!!',
        'supplier-updated': 'Supplier updated!!!',
        'supplier-created': 'Supplier created!!!',
        'something-went-wrong': 'Something went wrong, please try again.',

        'sync-agents': 'Sync agents',
        'sure-sync': 'Are you sure want sync?',
        'agents-merged-successfully': 'Agents merged successfully',
        'transform-to-company': 'Transform to company',
        'sure-transform': 'Are you sure want transform private agent to company?',
        'agents-transformed-successfully': 'Agents transformed successfully',
        'search-by-name-account-business-number': 'Search...',
        'agents': 'Agents',
        'client-number': 'Client Number',
        'supplier-number': 'Supplier Number',
        'user-number': 'User Number',
        'company-number': 'Company Number',
        'push-agents': 'Push agents',
        'agents-pushed-successfully': 'Agents pushed successfully',
        'sure-push': 'Are you sure want push?',
        'reset': 'Reset',
        'sync-docs': 'Sync Documents',
        'sync-storage-docs': 'Sync Storage To Documents',
        'docs-merged-successfully': 'Documents Merged Successfully',
        'documents': 'Documents',
        'receipts': 'Receipts',
        'view-payslip': 'View payslip',
        'view-monthly-report': 'View monthly report',
        'attachments': 'Attachments',
        'receipt-number': 'Receipt number',
        'supplier': 'Supplier',
        'due-date': 'Due date',
        'no-documents-found': 'No documents found',
        'negdi': 'Negdi',
        'nogl': 'Nogl',
        'yeuls': 'Yeuls',
        'agent': 'Agent',
        'hide-not-paid-income': 'Hide not paid income',
        'show-not-paid-income': 'Show not paid income',
        'hide-not-paid-outcome': 'Hide not paid outcome',
        'show-not-paid-outcome': 'Show not paid outcome',
        'soon': 'soon!',
        'new': 'new!',
        'salary': 'Salary',
        'year': 'Year',
        'month': 'Month',
        'client': 'Client',
        'import-salaries': 'Import salaries for ',
        'sure-import': 'You going to import salaries for {0}. Are you sure?',
        'import-finished': 'Import finished',
        'oketz-cost': 'Oketz cost',
        'oketz-net': 'Oketz net',
        'oketz-net-to-pay': 'Oketz net to pay',
        'salary-tile-total': 'Total salaries',
        'salary-tile-first': 'Total 1st salaries',
        'salary-tile-ninth': 'Total 9th salaries',
        'salary-tile-monthly-files': 'Total monthly files done',
        'salary-tile-salary-files': 'Total salary files done',
        'salary-col-employee': 'Employee / ID',
        'salary-col-status': 'Summary status',
        'monthly-link-table-header': 'Monthly summary',
        'salary-link-table-header': 'Payslip',
        'select-import-month': 'Please select import month',
        'sync-salaries': 'Sync salary data',
        'salary-actions': 'Actions',
        'send-to-maskoreshet': 'Send to Maskoreshet',
        'sent-to-maskoreshet': 'Sent to Maskoreshet',
        'summary-only': 'Summary only',
        'salary-missing-key': 'Please put the key',
        'send': 'Send',
        'sent': 'Sent',
        'maskoreshet-sent-successfully': 'Salary sent to Maskoreshet successfully',
        'generate-pdf': 'Generate PDF',
        'restart-pdf-generation': 'Restart PDF Generation',
        'generating-pdf': 'Generating PDF...',
        'pdf-generated': 'PDF Generated',
        'pdf-generation-completed': 'PDF generation completed',
        'pdf-generation-failed': 'PDF generation failed',
        'job-restarted': 'Job restarted successfully',
        'failed-to-restart-job': 'Failed to restart job',
        'pdf-generation-started': 'PDF generation started',
        'failed-to-start-generation': 'Failed to start PDF generation',
        "confirm-generate-pdf-title": "Generate documents for {{month}}-{{year}}",
        "confirm-generate-pdf-subtitle": "This action will generate <count>{{count}}</count> monthly reports. Continue?",
        'salaries-merged-successfully': 'Salary data synced successfully',
        'balance': 'Balance',
        'record-type': 'Type',
        'amount-before-vat': 'Before vat',
        'delete': 'Delete',
        'link-button-1': 'New Expense Request',
        'link-button-2': 'New Invoice Request',
        'link-button-3': 'New Issue Request',
        'additional-links-title': 'Forms and Requests',
        // New Home Page Components Translations
        'welcome-title': 'Welcome to Yeul Sachir Portal!',
        'welcome-description1': 'We are happy that you joined the service, and now you are in the portal that allows you to manage',
        'welcome-description2': 'in a convenient, simple and advanced way all your financial matters as employees through Yeul Sachir.',
        'inquiries-title': 'Inquiries and Forms',
        'invoice-request-title': 'Invoice Request',
        'invoice-request-description': 'Invoice generation for clients',
        'expense-request-title': 'Expense Request',
        'expense-request-description': 'Payment to supplier, business purchase, etc.',
        'service-call-title': 'Open Service Call',
        'service-call-description': 'For any question, problem or request',

        // Request forms (invoice request, expense request, support ticket)
        'loading': 'Loading...',
        'no-results': 'No results',
        'uploading': 'Uploading...',
        'fill-required-fields': 'Please fill in all required fields.',
        'field-is-required': 'This field is required.',
        'attachment-too-large': 'Each file must be up to 10MB.',

        'invoice-request-page-subtitle': 'Fill in the details and our team will generate the invoice',
        'submit-invoice-request': 'Submit Invoice Request',
        'who-is-the-client': 'Who is the client?',
        'search-client-placeholder': 'Search client by name or ID...',
        'no-clients-linked-to-you': 'No clients are linked to your account yet.',
        'invoice-details': 'Invoice Details',
        'payment-terms-label': 'Payment Terms for the Invoice',
        'select-payment-terms': 'Select payment terms...',
        'payment-terms-immediate': 'Immediate',
        'payment-terms-current-month': 'Current Month',
        'payment-terms-net-30': 'Net 30',
        'payment-terms-net-60': 'Net 60',
        'payment-terms-net-90': 'Net 90',
        'is-recurring-invoice': 'Is This a Recurring Invoice?',
        'is-recurring-invoice-helper': 'Applicable if the service recipient and amount are fixed each month',
        'recurring-invoice-yes': 'Yes - Recurring Invoice',
        'recurring-invoice-no': 'No - One-time invoice',
        'recurring-day': 'Day of month',
        'select-recurring-day': 'Select day 1-28',
        'currency-ils': '₪ ILS',
        'currency-usd': '$ USD',
        'currency-eur': '€ EUR',
        'currency-gbp': '£ GBP',
        'vat-inclusion': 'VAT Inclusion',
        'vat-inclusion-excluding': 'Excluding VAT (VAT will be added)',
        'vat-inclusion-including': 'Including VAT (VAT included in price)',
        'invoice-notes': 'Invoice Notes',
        'invoice-notes-placeholder': 'Notes to appear on the invoice...',
        'invoice-line-items': 'Invoice Line Items',
        'description-of-services': 'Description of Services',
        'description-of-services-placeholder': 'Describe the services provided...',
        'description-of-services-helper': 'Description of Services Provided',
        'line-description': 'Description / Item',
        'line-description-placeholder': 'Service / Item description',
        'line-quantity': 'Qty',
        'line-unit-price': 'Unit Price',
        'line-vat': 'VAT',
        'line-total': 'Line Total',
        'vat-18': 'VAT 18%',
        'vat-0': 'VAT 0%',
        'vat-exempt': 'Exempt',
        'add-line': '+ Add Line',
        'subtotal-excl-vat': 'Subtotal (excl. VAT)',
        'vat-amount': 'VAT',
        'total-payable': 'Total Payable',
        'invoice-request-submitted': 'Invoice request submitted successfully.',

        'expense-request-page-subtitle': 'Report a business expense — supplier, purchase, service or other payment',
        'submit-expense-request': 'Submit Expense Request',
        'attach-receipt': 'Attach Receipt',
        'attach-receipt-dropzone-title': 'Click to attach invoice / receipt or drag here',
        'attach-receipt-dropzone-hint': 'Important: attach a clear photo showing expense type, supplier name, and amount · PDF, JPG, PNG up to 10MB',
        'receipt-is-required': 'A receipt is required.',
        'supplier-service-provider': 'Supplier / Service Provider',
        'search-supplier-placeholder': 'Search supplier by name or ID...',
        'no-suppliers-linked-to-you': 'No suppliers are linked to your account yet.',
        'expense-details': 'Expense Details',
        'expense-description': 'Expense Description',
        'expense-description-placeholder': 'Why was this payment needed? (e.g., "training", "equipment", "travel")',
        'expense-description-helper': 'Describe the purpose of the expense and its connection to business activity',
        'invoice-number-placeholder': 'INV-0001',
        'category': 'Category',
        'select-category': 'Select category...',
        'expense-category-office-supplies': 'Office Supplies',
        'expense-category-travel-fuel': 'Travel & Fuel',
        'expense-category-food-hospitality': 'Food & Business Hospitality',
        'expense-category-software-subscriptions': 'Software & Subscriptions',
        'expense-category-computer-electronics': 'Computer & Electronics',
        'expense-category-advertising-marketing': 'Advertising & Marketing',
        'expense-category-professional-services': 'Professional Services',
        'expense-category-training-education': 'Training & Education',
        'expense-category-communications': 'Communications',
        'expense-category-office-rent-maintenance': 'Office Rent & Maintenance',
        'expense-category-other': 'Other',
        'total-amount-incl-vat': 'Total Amount incl. VAT',
        'total-amount-helper': 'Enter the total amount as stated on the receipt',
        'includes-vat': 'VAT',
        'includes-vat-rate': 'Includes {{rate}}% VAT',
        'who-pays-for-the-expense': 'Who Pays for the Expense?',
        'bank-account-details-for-payment': 'Bank Account Details for Payment',
        'account-holder-name': 'Account Holder Name',
        'account-holder-name-placeholder': 'Full name',
        'bank-name-placeholder': 'Select bank...',
        'branch-number': 'Branch Number',
        'branch-number-placeholder': '0000',
        'account-number': 'Account Number',
        'account-number-placeholder': '000000',
        'paid-by-yeuls': 'Yeul Sachir (Company)',
        'paid-by-yeuls-hint': 'The expense will be deducted from your payslip income, excluding VAT',
        'paid-by-me': 'Me (Service Provider) — Reimbursement',
        'paid-by-me-hint': 'I paid out of pocket and request reimbursement from the company',
        'expense-request-submitted': 'Expense request submitted successfully.',

        'service-call-page-subtitle': 'For any question, issue, or request — we\'re here for you',
        'open-support-ticket': 'Open Support Ticket',
        'ticket-details': 'Ticket Details',
        'ticket-subject': 'Subject',
        'ticket-subject-placeholder': 'One-line summary of the issue or request',
        'target-department': 'Target Department',
        'select-target-department': 'Which team should handle this?',
        'department-it-computing': 'IT & Computing',
        'department-maintenance-operations': 'Maintenance & Operations',
        'department-hr-payroll': 'HR & Payroll',
        'department-finance-accounting': 'Finance & Accounting',
        'department-other': 'Other',
        'ticket-description': 'Detailed Description',
        'ticket-description-placeholder': 'Describe the issue, steps to reproduce, what you already tried...',
        'attachments-optional': 'Attachments (Optional)',
        'attach-file-dropzone-title': 'Click to upload screenshot / file or drag here',
        'attach-file-dropzone-hint': 'Useful for IT issues and operational problems · PDF, JPG, PNG up to 10MB',
        'support-ticket-submitted': 'Support ticket opened successfully.',

        'my-requests-title': 'My Requests',
        'my-requests-subtitle': 'Track all your requests, invoices and expenses',
        'all-requests-title': 'All Requests',
        'all-requests-subtitle': 'Track all requests submitted by users',
        'all-requests-tab': 'All',
        'invoice-requests-tab': 'Invoices',
        'expense-requests-tab': 'Expenses',
        'service-calls-tab': 'Service',
        'recurring-requests-tab': 'Recurring',
        'recurring-invoices-tracking': 'Recurring Invoices — Monthly Renewal Tracking',
        'recurring-status-renewing': 'Renewing',
        'renewal-history': 'Renewal History',
        'recurring-schedule-day': 'Day {{day}} of each month',
        'recurring-step-generated': 'Generated',
        'recurring-step-in_progress': 'In Progress',
        'recurring-step-pending': 'Pending',
        'recurring-step-skipped': 'Skipped',
        'recurring-step-next': 'Next',
        'recurring-month-jan': 'Jan',
        'recurring-month-feb': 'Feb',
        'recurring-month-mar': 'Mar',
        'recurring-month-apr': 'Apr',
        'recurring-month-may': 'May',
        'recurring-month-jun': 'Jun',
        'recurring-month-jul': 'Jul',
        'recurring-month-aug': 'Aug',
        'recurring-month-sep': 'Sep',
        'recurring-month-oct': 'Oct',
        'recurring-month-nov': 'Nov',
        'recurring-month-dec': 'Dec',
        'requests-stat-total': 'Total',
        'requests-stat-pending': 'Pending',
        'requests-stat-completed': 'Completed',
        'requests-stat-recurring': 'Recurring',
        'search-requests-placeholder': 'Search by description, client, supplier...',
        'all-statuses': 'All statuses',
        'request-type-invoice': 'Invoice',
        'request-type-expense': 'Expense',
        'request-type-service': 'Service',
        'no-requests-yet': 'No requests here yet.',
        'no-attachments': 'No files attached.',
        'request-id': 'Request ID',
        'request-view-close': 'Close',
        'submitted-by': 'Submitted By',
        'recurring-invoice': 'Recurring',
        'expense-category': 'Category',
        'subject': 'Subject',
        'request-status-new': 'Pending',
        'request-status-in_progress': 'In Progress',
        'request-status-done': 'Completed',
        'request-status-rejected': 'Rejected',

        'features-title': 'What can you see and do in the portal?',
        'salary-slips-title': 'Requests and Questions',
        'salary-slips-description': 'Forms for Various Requests & Questions',
        'final-report-title': 'Final Summary Report',
        'final-report-description': 'You can view a report that clearly shows where all the income for your salary slip came from.',
        'our-services-title': 'Our services include:',
        'financial-treatment-title': 'Full Financial Treatment:',
        'financial-treatment-description': ' No need to open an independent file with the Tax Authority or National Insurance.',
        'social-rights-title': 'Social Rights:',
        'social-rights-description': ' Possibility for unemployment benefits and maternity benefits.',
        'professional-consultation-title': 'Professional Consultation:',
        'professional-consultation-description': ' Personal financial and insurance consultation from experts in the field.',
        'important-to-know-title': 'What else is important to know?',
        'managed-forms-title': 'Managed Forms:',
        'managed-forms-description': ' All forms (such as Form 101) are managed through the portal automatically.',
        'tracking-updates-title': 'Tracking and Updates:',
        'tracking-updates-description': ' You will receive notifications and updates on inquiry status directly in the portal.',
        'video-guides-title': 'Training Videos',
        'hebrew-video-title': 'Salary Slip Video',
        'hebrew-video-description': 'Detailed explanation of the payslip',
        'english-video-title': 'Salary Slip Video',
        'english-video-description': 'A detailed explanation of the payslip',
        'all-rights-reserved': 'All rights reserved. Fincome |יעול שכיר ©',
        'personal-support-title': 'Personal and Always Available Service',
        'personal-support-description': 'Natali, our success relationship manager, is here to serve you and will handle any problem if you haven\'t managed to fill out the forms or any other issue. Don\'t hesitate to contact us!',
        'copyright-text': '© 2024 All rights reserved to Yeul Sachir Ltd.',
        'docs-title': 'Viewing documents',
        'docs-description': 'All invoices, receipts, and payslips are centralized in one place, accessible for download at any time.',
        'otp-has-been-sent': "We've sent a One-Time Password (OTP) to your email.",
        'code-will-expire-in-5-mins': 'The code will expire in 5 minutes.',
        'login-title': "Welcome to the Yeuls Employee Portal | Fincome!",
        'login-subtitle': 'View pay slips, expenses and income, submit refund requests, and upload invoices. We are here for any questions, including direct contact through the system.',
        'login-footer-title': 'Everything you need in one place',
        from: 'From',
        to: 'To',
        true: 'TRUE',
        false: 'FALSE',
        'email-tracking-report-title': 'Email Tracking Report',
        'email-tracking-load-report': 'Load Report',
        'email-tracking-range-label': 'Range',
        'email-tracking-range': 'Range: {{from}} - {{to}}',
        'email-tracking-email-title': 'Email {{index}}',
        'email-tracking-no-data-for-email': 'No data available for this email.',
        'email-tracking-select-range-and-load': 'Select a date range and click Load Report.',
        'email-tracking-select-from-to-dates': 'Please select from and to dates.',
        'email-tracking-invalid-range': 'From date must be earlier than or equal to To date',
        'email-tracking-max-range-week': 'Date range cannot be more than 7 days',
        'email-tracking-something-went-wrong': 'Something went wrong. Please try again.',
        'email-tracking-no-emails-found': 'No emails found in the selected date range.',
        'email-tracking-filter-unsent': 'Show only unsent emails',
        'email-tracking-col-email-date': 'Email Date',
        'email-tracking-col-sender-address': 'Sender',
        'email-tracking-col-file-number': 'File Number',
        'email-tracking-col-file-type': 'File Type',
        'email-tracking-col-user-no': 'User Number',
        'email-tracking-col-client-no': 'Client Number',
        'email-tracking-col-user-email': 'User Email',
        'email-tracking-col-client-email': 'Client Email',
        'email-tracking-col-sent-to-user': 'Sent To User',
        'email-tracking-col-reason-not-sent-to-user': 'Reason Not Sent To User',
        'email-tracking-col-sent-to-client': 'Sent To Client',
        'email-tracking-col-reason-not-sent-to-client': 'Reason Not Sent To Client',
        'email-tracking-reason-unknown-type': 'File type could not be classified',
        'email-tracking-reason-unknown-number': 'File number could not be extracted from filename',
        'email-tracking-reason-invoice-not-found': 'Invoice not found in database',
        'email-tracking-reason-receipt-not-found': 'Receipt not found in database',
        'email-tracking-reason-user-not-found-invoice': 'No user found for this invoice',
        'email-tracking-reason-user-not-found-receipt': 'No user found for this receipt',
        'email-tracking-reason-client-not-found-invoice': 'No client found for this invoice',
        'email-tracking-reason-client-not-found-receipt': 'No client found for this receipt',
        'email-tracking-reason-user-email-missing': 'User email is missing',
        'email-tracking-reason-client-email-missing': 'Client email is missing',
        'email-tracking-reason-unauthorized-sender': 'Email from an unauthorized sender',
        'email-tracking-reason-no-attachments': 'Email has no attachments',
        'email-tracking-reason-company-id-not-allowed': 'Company ID is not allowed',
        'email-tracking-reason-email-mismatch': 'Email mismatch between databases',
        'email-tracking-reason-storage-upload-failed': 'File upload to storage failed',
        'email-tracking-reason-document-update-failed': 'Document update failed',
        'email-tracking-reason-email-send-failed': 'Email send failed',
        'email-tracking-reason-email-already-sent': 'Email already sent',
        'email-tracking-reason-internal-server-error': 'Internal server error',
        'auth-history-report-title': 'Auth History',
        'auth-history-load-report': 'Load Report',
        'auth-history-range-label': 'Range',
        'auth-history-select-from-to-dates': 'Please select from and to dates.',
        'auth-history-invalid-range': 'From date must be earlier than or equal to To date',
        'auth-history-something-went-wrong': 'Something went wrong. Please try again.',
        'auth-history-no-records-found': 'No auth history found in the selected date range.',
        'auth-history-col-date': 'Date',
        'auth-history-col-device-type': 'Device',
        'auth-history-col-user-name': 'Name',
        'auth-history-col-email': 'Email',
        'auth-history-col-identity-number': 'Identity Number',
        'auth-history-col-role': 'Role',
        'auth-history-col-agent-id': 'Agent ID',
        'auth-history-last-login': 'Last login',
        'auth-history-logins-count': 'Logins',
        'sync-from-maskoreshet': 'Sync from Maskoreshet',
        'data-synced-from-maskoreshet': 'Data synced from Maskoreshet successfully'
      },
    },
    heb: {
      translation: {
        language: 'שפה',
        'eng-lang-button': 'אנגלית',
        'heb-lang-button': 'עברית',
        'e-mail': 'אימייל',
        'enter-ID-number': ' מספר תעודת זהות',
        'enter-email-address': ' כתובת אימייל',
        password: 'סיסמה',
        'forgot-password': '?שכחת סיסמה',
        'sign-in': 'התחבר',
        'otp-sign-in': 'התחברות עם סיסמה חד פעמית',
        'otp-sign-up': 'הרשמה עםסיסמה  חד פעמית',
        'email-sign-in': 'התחברות עם אימייל וסיסמה',
        'email-sign-up': 'הרשמה עם אימייל וסיסמה',
        'or-string': 'או',
        'one-time-code': 'סיסמה חד פעמית',
        'verify-and-login': 'אימות והתחברות',
        'verification-code': 'קוד אימות',
        'code-sent-to': 'יש להזין את הקוד שנשלח לכתובת',
        'send-new-code': 'שלח קוד מחדש',
        'fill-all-fields': 'נא למלא את כל השדות',
        'invalid-email': 'כתובת אימייל לא תקינה',
        'invalid-id-number': 'מספר תעודת זהות חייב להכיל לפחות 7 ספרות',
        'invalid-otp-code': 'קוד אימות שגוי',
        'get-one-time-password': "שליחת קוד",
        'got-password': ".נשלחה סיסמה לכתובת האימייל שלך",
        'send-password-again': 'לא קיבלת סיסמה? שליחה חוזרת',
        'use-regular-password': 'שימוש בסיסמה רגילה',
        'code': 'קוד חד פעמי',
        'didnt-get-code': 'קוד לא התקבל',
        'resend': 'שליחה חוזרת',
        'monthly-overview-upper-case': 'מסמכים',
        'all-files': 'כל המסמכים',
        'all-files-upper-case': 'כל המסמכים',
        'employees': 'סוכנים',
        files: 'מסמכים',
        invoices: 'חשבוניות',
        expenses: 'הוצאות',
        salaries: 'ריכוזים ותלושי שכר',
        payslip: 'תלושי שכר',
        'document-not-available': 'המסמך אינו זמין',
        'try-again-later': 'נסה שוב מאוחר יותר',
        'profile-info': 'הפרופיל שלי',
        name: 'שם מלא',
        phone: 'טלפון',
        'created-date': 'תאריך',
        type: 'סוג',
        customer: 'לקוח',
        'total-nis': 'סכום בשקלים',
        'total-paid': 'סה"כ שולם',
        'total-estimation': ':סה"כ משוער',
        nis: 'ש"ח',
        'salaries-subtitle': 'הריכוז החודשי ותלוש השכר יתעדכן מדי חודש ב-15 לחודש',
        'my-salary': 'תלוש שכר',
        'monthly-overview': 'המסמכים שלי',
        invoice: 'חשבונית מס',
        receipt: 'קבלה',
        'invoice/receipt': 'חשבונית מס/קבלה',
        'invoice-c': 'חשבונית זיכוי',
        back: 'חזרה',
        'company-name': 'שם חברה',
        'street-address': 'כתובת',
        city: 'עיר',
        'email-address': 'אימייל',
        'phone-number': 'טלפון',
        'invoice-number': 'מספר חשבונית',
        'bill-to': ':עבור',
        description: 'תיאור',
        'service-fee': 'עמלה',
        labor: 'זמן עבודה',
        'hours-at': 'שעות',
        hr: 'כח אדם',
        'new-client-discount': 'הנחה',
        tax: 'מע"מ',
        thanks: '!תודה',
        total: 'סה"כ',
        'auth-error': 'שגיאה בהתחברות, נא נסה שנית',
        // TODO: replace value to Personal ID
        'identity-number': 'ת.ז',
        'dont-have-account': '?אין לך חשבון',
        'already-have-account': '?כבר רשום',
        'contact-with-us': 'פרטי התקשרות',
        'sign-up': 'הירשם',
        job: 'מקצוע',
        'update-details': 'עדכן פרטים',
        'sign-out': 'יציאה',
        'session-expired': 'פג תוקף ההתחברות שלך. אנא התחבר שוב.',
        January: 'ינואר',
        February: 'פברואר',
        March: 'מרץ',
        April: 'אפריל',
        May: 'מאי',
        June: 'יוני',
        July: 'יולי',
        August: 'אוגוסט',
        September: 'ספטמבר',
        October: 'אוקטובר',
        November: 'נובמבר',
        December: 'דצמבר',
        'part-number': 'מק"ט', // Part Number
        'unit-price': 'מחיר', // Unit Price
        'total-price': 'סה"כ', // Total Price
        qty: 'כמות', // Qty
        'sub-total': 'לפני מע"מ', // Sub Total
        discount: 'הנחה', // Discount
        vat: 'מע"מ', // Vat of 17%
        number: 'אסמכתא', // Number
        'company-general-title': '‫בע"מ‬ ‫ופיתוח‬ ‫מחקר‬ ‫שכיר‬ ‫יעול‬ ‫י‪.‬ש‬',
        'company-address': `‫‪9107901‬‬ ‫ירושלים‬ ‫‪,7992‬‬ ‫ת‪.‬ד‪.‬‬ ‫ג‪,‬‬ ‫כניסה‬ ‫‪16‬‬ ‫ג'ורג‬ ‫המלך‬ ‫רחוב‬ ‫כתובת‪:‬‬`,
        'support-phone': '054-261-8904',
        'company-dealer': '‫‪514129717‬‬ ‫מורשה‪:‬‬ ‫עוסק‬',
        'invoice-note-row-1': `‫למעלה‬ ‫הרשום‬ ‫לת‪.‬ד‬ ‫בצ'ק‬ ‫בע"מ"‬ ‫ופיתוח‬ ‫מחקר‬ ‫שכיר‬ ‫ל"ייעול‬ ‫לשלוח‬ ‫יש‬ ‫חשבוניות‬ ‫עבור‬ ‫תשלומים‬`,
        'invoice-note-row-2':
          '‫‪517‬‬ ‫סניף‬ ‫‪188832‬‬ ‫חשבון‬ ‫טפחות‬ ‫מזרחי‬ ‫לבנק‬ ‫בנקאית‬ ‫העברה‬ ‫לבצע‬ ‫או‬',
        'invoice-note-row-3':
          '‫השירות‬ ‫נותן‬ ‫שם‬ ‫או‬ ‫החשבונית‬ ‫מספר‬ ‫את‬ ‫ההעברה‬ ‫בפרטי‬ ‫לכלול‬ ‫יש‬ ‫העברה‬ ‫ביצוע‬ ‫בעת‬',
        'invoice-note-row-4': `‫‪vered@yeuls.co.il‬‬ ‫למייל‬ ‫צ'ק‬ ‫הפקדת‬ ‫אישור‬ ‫או‬ ‫העברה‬ ‫אישור‬ ‫אלינו‬ ‫לשלוח‬ ‫חובה‬`,
        'invoice-note-row-5': '‫תודה‬',
        'invoice-note-row-6': '‫!‬ ‫במקור‬ ‫מניכוי‬ ‫מלא‬ ‫פטור‬',
        'invoice-note-row-7': '',
        'invoice-note-row-8': '',
        'home-page-title': 'ברוך הבא ליעול שכיר',
        'home-page': 'ראשי',
        'project-management': 'ניהול פרויקטים',
        'general-docs': 'מסמכים כלליים',
        'general-docs-subtitle': 'כאן ניתן לצפות ולהוריד את מסמכי העבודה האישיים שלך, חוזי העסקה וטפסי מס.',
        'contact-us-title': 'פרטי יצירת קשר',
        'general-manager': 'רודן - מנכ"ל',
        'contact-info': 'פרטי התקשרות',
        'office-manager': 'רימה – מנהלת יעול שכיר , משכורות , בנקים',
        'payroll-accounting': 'אורה - חשבת שכר',
        billing: 'אושרת  – חשבוניות , הוצאות , גביה',
        'accounting-manager': 'ענבל - הנהלת חשבונות לעצמאים',
        'savings-pension': 'דניאל - מנהל פיתוח עסקי',
        'operations-manager': 'נטלי - מנהל תפעול',
        'yeul-sachir-title': 'יעול שכיר',
        'mailing-address-title': ':כתובת למשלוח דואר',
        'mailing-address': 'ת.ד. 7992 ירושלים 9107901',
        'office-address-title': ':כתובתנו החדשה',
        'office-address': 'המלך גורג 16 כניסה ג קומה 10, ירושלים',
        telephone: ':טלפון',
        fax: ':פקס',
        'bank-info-title': 'פרטי בנק',
        'bank-title-1': 'יעול שכיר מחקר ופיתוח בע"מ',
        'bank-mizrachi-tefachot': 'בנק מזרחי טפחות',
        'bank-number-20': 'בנק 20',
        'bank-brach-number': 'בנק מזרחי סניף 517',
        'bank-account-number-1': 'חשבון 188832',
        'bank-title-2': 'יעול שכיר בע"מ',
        'bank-account-number-2': 'חשבון 103888',
        'mail-info-title': 'כתובת',
        'monthly-summary': 'ריכוז חודשי',
        'us-bank-details': 'פרטי בנק ארה"ב',
        'no-files': 'אין מסמכים',
        'search-by-user-id': 'חיפוש לפי ת.ז',
        search: 'חיפוש',
        'search-helper-text': 'חיפוש לפי ת.ז או שם עובד',
        'search-by-invoice-number': 'חיפוש לפי מספר חשבונית',
        'search-by-receipt-number': 'חיפוש לפי מספר קבלה',
        'general-search': 'חיפוש...',
        'not-complite-registration': 'העובד טרם השלים את הרשמתו לפורטל',
        'send-instructions': 'אישור ושליחה',
        'reset-password': 'איפוס סיסמה',
        'reset-password-text': 'יש להזין כתובת מייל כפי שהיא רשומה במערכת',
        'check-your-email-instructions': 'שלחנו אלייך מייל עם הוראות',
        'check-your-email': 'נשלח אליך מייל',
        'check-spam': 'אם לא קיבלת מייל',
        'try-another-email': 'נסה שנית',
        'create-password': 'יצירת סיסמה חדשה',
        'origin-amount': 'סכום',
        rate: 'שער',
        'currency-type': 'מטבע',
        'monthly-files': 'ריכוזים חודשיים',
        'upload-files': 'העלאת מסמכים לעובדים',
        'drag-n-drop': 'העלאת קבצים לפה על ידי גרירה או בחירה',
        'drag-n-drop-format': 'יש להעלות קבצים בפורמט הבא בלבד:',
        'file-number': 'מספר קובץ',
        'file-name': 'שם קובץ',
        'file-type': 'סוג',
        user: 'שם סוכן',
        'missed-files': 'דוח מסמכים חסרים',
        'notes': 'הערות',
        'id': 'ת.ז',
        'agent-id': 'מספר סוכן',
        'email': 'אימייל',
        'status': 'סטטוס',
        'active': 'פעיל',
        'dismissed': 'לא פעיל',
        'company-id': 'מספר חברה',
        'with-capital-employees': 'עובדים',
        'agents-list': 'סוכנים',
        'companies-list': 'חברות',
        'search-by-all-fields': 'חיפוש לפי, שם, ת.ז, מספר סוכן, אימייל',
        'monthly-report': 'דו"ח חודשי',
        'days': 'ימים',
        'cost': 'עלות',
        'fee': 'עמלה',
        'daily-rate-with-colon': 'תעריף יומי: ',
        'hourly-rate-with-colon': 'תעריף שעתי: ',
        'daily-off-rate': 'שבת \ חג:',
        'exchange-rate': 'שער חליפין:',
        'total-cost-with-colon': 'סה"כ עלות',
        'total-fee': 'סה"כ עמלה:',
        'send-report': 'שליחת דו"ח',
        'profile': 'פרופיל',
        'date': 'תאריך רישום',
        'note': 'פרטים',
        'amount': 'סכום אחרי מע"מ',
        'half-day-50': 'חצי יום 50%',
        'transit-60': 'טרנזיט 60%',
        'day-100': 'יום רגיל 100%',
        'day-off-150': 'יום חופש 150%',
        'cancel': 'ביטול',
        'confirm': 'אישור',
        'validate-and-approve': 'בדיקה ואישור',
        'open': 'פתוח',
        'closed': 'סגור',
        'ready': 'מוכן',
        'in-progress': 'בטיפול',
        'admin-panel': 'איזור מנהל',
        'firstname': 'שם פרטי',
        'lastname': 'שם משפחה',
        'create-user': 'יצירת סוכן',
        'admin': 'אדמין',
        'role': 'סוג משתמש',
        'company': 'חברה',
        'create-company': 'יצירת חברה',
        'is-use-daily-rate': 'האם תעריף יומי?',
        'hourly-rate': 'תעריף שעתי',
        'daily-rate': 'תעריף יומי',
        'employee': 'עובד',
        'manager': 'מנהל',
        'create-company-user': 'יצירת סוכן',
        'done': 'הסתיים',
        'pending': 'ממתין',
        'hours': 'שעות',
        'currency': 'מטבע',
        'include-vat-17': 'כולל מע"מ 17%',
        'create-invoice': 'הפקת חשבונית',
        'send-on-email': 'האם לשלוח אימייל?',
        'yes': 'כן',
        'no': 'לא',
        '1st': '1 לחודש',
        '9st': '9 לחודש',
        'total-income': 'סה"כ הכנסות',
        'total-expense': 'סה"כ הוצאות',
        'amount-vat-17': 'כולל מע"מ 17%',
        'paid-by': 'שולם ע"י',
        'total-income-with-colon': ':סה"כ הכנסות',
        'total-outcome-with-colon': ':סה"כ הוצאות',
        'add-income': 'השלמת הכנסה',
        'split-income': 'פיצול הכנסה',
        'split-outcome': 'פיצול הוצאה',
        'reset-salary': 'איפוס',
        'save-salary': 'שמירה',
        'edit-user': 'עריכה',
        'actions': 'פעולות',
        'update-user': 'עדכון פרטי סוכן',
        'user-terms': 'פרטי העסקה',
        'yeuls-fee': '(0-100%) עמלה',
        'salary-date': 'תאריך השכר',
        'calculation-type': 'סוג החישוב',
        'max-yeuls-fee': 'מקסימום עמלה',
        'first': '1 לחודש',
        'ninth': '9 לחודש',
        'gross': 'לפי ברוטו',
        'edit-company': 'עריכה',
        'update-Company': 'עדכון פרטי החברה',
        'company-terms': 'תנאי העסקה ותשלום',
        'update-company-user': 'עדכון סוכן בחברה',
        'create-csv': 'ייצוא לאקסל',
        'search-by-name-and-id': 'חיפוש לפי שם הסוכן, מספר סוכן בעמית',
        'paid': 'שולם',
        'not-paid': 'לא שולם',
        'total-fee-cost': 'סה"כ עמלה',
        'total-cost': 'עלות שכר',
        'total-net': 'נטו לתשלום',
        'export-to-csv': 'ייצוא לעוקץ',
        'import-csv': 'ייבוא מעוקץ',
        'oketz-number': 'מספר סוכן בעוקץ',
        'country': 'מדינה',
        'address': 'רחוב ומספר',
        'car-details': 'פרטי רכב',
        'report-type': 'סוג דוח',
        'start-date': 'תאריך תחילת עבודה',
        'end-date': 'תאריך סיום עבודה',
        'bank-name': 'שם בנק',
        'bank-number': 'מספר בנק',
        'bank-branch-number': 'מספר סניף',
        'bank-account-number': 'מספר חשבון בנק',
        'insurance-notes': 'הערות לביטוח',
        'next': 'הבא',
        'hourly': 'שכר עתי',
        'daily': 'שכר יומי',
        'fixed': 'שכר גלובלי',
        'general': 'פרטים כללים',
        'terms-and-conditions': 'תנאים ופרטי העסקה',
        'bank': 'פרטי בנק',
        'insurance': 'ביטוח',
        'edit': 'עריכה',
        'save': 'שמירה',
        'santec-account-id': 'מספר סוכן בעמית',
        'default-daily-rate': 'תעריך יומי',
        'companies': 'חברות',
        'user-companies-empty-list': 'סוכן אינו משויך לאף חברה',
        'included-vat': 'כולל מע"מ',
        'users': 'סוכנים',
        'report-fee': 'עמלה',
        'heb': 'עברית',
        'eng': 'אנגלית',
        'USD': 'דולר',
        'NIS': 'שקל',
        'EUR': 'יורו',
        'registration-fee': 'דמי רישום',
        'registration-fee-paid': 'דמי רישום שולמו',
        'registration-fee-free': 'פטור מדמי רישום',
        'clients-list': 'לקוחות',
        'suppliers-list': 'ספקים',
        'create-client': 'לקוח חדש',
        'create-supplier': 'ספק חדש',
        'client-name': 'שם לקוח',
        'business-number': 'ח.פ \ מספר עוסק',
        'withholding-tax': 'ניכוי במקור',
        'withholding-tax-expiration': 'תוקף ניכוי במקור',
        'general-ledger': 'תוקף ניהול ספרים',
        'zip': 'מיקוד',
        'created-by': 'נוצר על יד',
        'agents-count': 'מספר סוכנים',
        'to-search-message': 'חיפוש',
        'client-companies-empty-list': 'לא קיימים חשבונות מחוברים',
        'client-users-empty-list': 'לא קיימים חשבונות מחוברים',
        'supplier-companies-empty-list': 'לא קיימים חשבונות מחוברים',
        'supplier-users-empty-list': 'לא קיימים חשבונות מחוברים',
        'supplier-name': 'שם ספק',
        'accounts': 'חשבונות',
        'links': 'חשבונות מחוברים',
        'clients': 'לקוחות',
        'suppliers': 'ספקים',
        'user-clients-empty-list': 'לסוכן אין לקוחות משוייכים',
        'user-suppliers-empty-list': 'לסוכן אין ספקים משוייכים',
        'company-clients-empty-list': 'לחברה אין לקוחות משוייכים',
        'company-suppliers-empty-list': 'לחברה אין ספקים משוייכים',
        'employees-list': 'חשבונות',
        'user-updated': 'סוכן עודכן בהצלחה',
        'user-created': 'סוכן הוקם בהצלחה',
        'company-updated': 'סוכן-חברה עודכן בהצלחה',
        'company-created': 'סוכן-חברה הוקם בהצלחה',
        'client-updated': 'לקוח עודכן בהצלחה',
        'client-created': 'לקוח הוקם בהצלחה',
        'supplier-updated': 'ספק עודכן בהצלחה',
        'supplier-created': 'ספק הוקם בהצלחה',
        'something-went-wrong': 'אירעה שגיאה, אנא נסה שנית.',
        'sync-agents': 'סנכרון חשבונות מעמית',
        'sure-sync': 'אישור פעולת סנכרון חשבונות',
        'agents-merged-successfully': 'סוכנים סונכרנו בהצלחה',
        'transform-to-company': 'הפיכת סוכן לחברה',
        'sure-transform': 'פעולה זו תהפוך סוכן לחברה האם אתה בטוח?',
        'agents-transformed-successfully': 'סוכנים עודכנו בהצלחה',
        'search-by-name-account-business-number': 'חיפוש...',
        'agents': 'סוכנים',
        'client-number': 'מספר לקוח',
        'supplier-number': 'מספר ספק',
        'user-number': 'מספר סוכן',
        'company-number': 'עוסק מורשה',
        'push-agents': 'סנכרון סוכנים לעמית',
        'agents-pushed-successfully': 'סוכנים עודכנו בהצלחה בעמית',
        'sure-push': 'פעולה זו תיצור סוכנים בעמית לחיצה לאישור סנכרון',
        'reset': 'איפוס',
        'sync-docs': 'סנכרון מסמכים',
        'sync-storage-docs': 'סנכרון קישורים למסמכים',
        'docs-merged-successfully': 'מסמכים הועלו בהצלחה',
        'documents': 'מסמכים',
        'receipts': 'קבלות',
        'view-payslip': 'הצג תלוש',
        'view-monthly-report': 'הצג ריכוז',
        'attachments': 'קבצים מצורפים',
        'receipt-number': 'מספר קבלה',
        'supplier': 'ספק',
        'due-date': 'תאריך ערך',
        'no-documents-found': 'לא נמצאו מסמכים',
        'negdi': 'נגדי',
        'nogl': 'Nogl',
        'yeuls': 'יעול שכיר',
        'agent': 'סוכן',
        'hide-not-paid-income': 'הסתר חשבוניות פתוחות',
        'show-not-paid-income': 'כולל חשבוניות פתוחות',
        'hide-not-paid-outcome': 'הסתר הוצאות שלא שולמו',
        'show-not-paid-outcome': 'כולל הוצאות שלא שולמו',
        'soon': 'בקרוב',
        'new': 'חדש!',
        'salary': 'תלוש שכר',
        'year': 'שנה',
        'month': 'חודש',
        'client': 'לקוח',
        'import-salaries': 'העלאת נתונים מעוקץ',
        'sure-import': 'הינך מעלה נתונים בעבור חודש {0}',
        'import-finished': 'טעינה מעוקץ הסתיימה בהצלחה',
        'oketz-cost': 'עלות מעוקץ',
        'oketz-net': 'נטו מעוקץ',
        'oketz-net-to-pay': 'נטו לתשלום מעוקץ',
        'salary-tile-total': 'סה"כ שכר',
        'salary-tile-first': 'שכר ל-1 לחודש',
        'salary-tile-ninth': 'שכר ל-9 לחודש',
        'salary-tile-monthly-files': 'ריכוזים שהופקו',
        'salary-tile-salary-files': 'תלושים שהופקו',
        'salary-col-employee': 'שם עובד / מזהה',
        'salary-col-status': 'סטטוס ריכוז',
        'monthly-link-table-header': 'ריכוז חודשי',
        'salary-link-table-header': 'תלוש',
        'select-import-month': 'יש לבחור חודש',
        'sync-salaries': 'סנכרון נתוני שכר',
        'salary-actions': 'פעולות',
        'send-to-maskoreshet': 'שליחה למשכורשת',
        'sent-to-maskoreshet': 'נשלח למשכורשת',
        'summary-only': 'הפקת ריכוז בלבד',
        'salary-missing-key': 'נא להזין את המפתח',
        'send': 'שליחה',
        'sent': 'נשלח',
        'maskoreshet-sent-successfully': 'השכר נשלח ל-Maskoreshet בהצלחה',
        'generate-pdf': 'הפקת PDF',
        'restart-pdf-generation': 'הפקה מחדש של PDF',
        'generating-pdf': 'מפיקים PDF...',
        'pdf-generated': 'PDF הופק',
        'pdf-generation-completed': 'PDF הפקת הושלמה',
        'pdf-generation-failed': 'PDF הפקת נכשלה',
        'job-restarted': 'התהליך הופעל מחדש בהצלחה',
        'failed-to-restart-job': 'נכשלה הפעלת התהליך מחדש',
        'pdf-generation-started': '...התחילה PDF הפקת',
        'failed-to-start-generation': 'נכשל PDF תהליך הפקת',
        "confirm-generate-pdf-title": "הפקת מסמכים עבור {{month}}-{{year}}",
        "confirm-generate-pdf-subtitle": "?פעולה זו תפיק <count>{{count}}</count> ריכוזים חודשיים. האם להמשיך",
        'salaries-merged-successfully': 'ריכוזים סונכרנו בהצלחה',
        'balance': 'יתרה',
        'record-type': 'סוג מסמך',
        'amount-before-vat': 'סכום לפני מע"מ',
        'delete': 'מחיקה',
        'link-button-1': 'בקשת הוצאה',
        'link-button-2': 'בקשת חשבונית',
        'link-button-3': 'פתיחת קריאת שירות',
        'additional-links-title': 'פניות וטפסים',
        // New Home Page Components Translations
        'welcome-title': 'ברוכים הבאים לפורטל יעול שכיר!',
        'welcome-description1': 'שמחים שהצטרפתם לשירות, ועכשיו אתם בפורטל המאפשר לכם לנהל בצורה נוחה, פשוטה ומתקדמת',
        'welcome-description2': ' את כל העניינים הפיננסיים שלכם כמועסקים דרך יעול שכיר',
        'inquiries-title': 'פניות וטפסים',
        'invoice-request-title': 'בקשה לחשבונית',
        'invoice-request-description': 'הפקת חשבונית עבור לקוחות',
        'expense-request-title': 'בקשה להוצאה',
        'expense-request-description': 'דיווח על תשלום לספק, קנייה עסקית וכל הוצאה רלוונטית',
        'service-call-title': 'פתיחת קריאת שירות',
        'service-call-description': 'לכל שאלה, בעיה או בקשה- אנחנו כאן בשבילכם',

        // Request forms (invoice request, expense request, support ticket)
        'loading': 'טוען...',
        'no-results': 'לא נמצאו תוצאות',
        'uploading': 'מעלה...',
        'fill-required-fields': 'נא למלא את כל שדות החובה.',
        'field-is-required': 'שדה חובה.',
        'attachment-too-large': 'כל קובץ יכול להיות בגודל של עד 10MB.',

        'invoice-request-page-subtitle': 'מלאו את הפרטים והצוות שלנו יפיק את החשבונית',
        'submit-invoice-request': 'שליחת בקשה לחשבונית',
        'who-is-the-client': 'מי הלקוח?',
        'search-client-placeholder': 'חיפוש לקוח לפי שם או מספר...',
        'no-clients-linked-to-you': 'אין לקוחות המשויכים לחשבון שלך.',
        'invoice-details': 'פרטי החשבונית',
        'payment-terms-label': 'תנאי תשלום לחשבונית',
        'select-payment-terms': 'בחרו תנאי תשלום...',
        'payment-terms-immediate': 'מיידי',
        'payment-terms-current-month': 'שוטף',
        'payment-terms-net-30': 'שוטף + 30',
        'payment-terms-net-60': 'שוטף + 60',
        'payment-terms-net-90': 'שוטף + 90',
        'is-recurring-invoice': 'האם זו חשבונית חוזרת?',
        'is-recurring-invoice-helper': 'רלוונטי אם מקבל השירות והסכום קבועים בכל חודש',
        'recurring-invoice-yes': 'כן - חשבונית חוזרת',
        'recurring-invoice-no': 'לא - חשבונית חד-פעמית',
        'recurring-day': 'יום בחודש',
        'select-recurring-day': 'בחרו יום 1-28',
        'currency-ils': '₪ שקל (ILS)',
        'currency-usd': '$ דולר (USD)',
        'currency-eur': '€ אירו (EUR)',
        'currency-gbp': '£ לירה שטרלינג (GBP)',
        'vat-inclusion': 'הכללת מע"מ',
        'vat-inclusion-excluding': 'לא כולל מע"מ (המע"מ יתווסף)',
        'vat-inclusion-including': 'כולל מע"מ (המע"מ כלול במחיר)',
        'invoice-notes': 'הערות לחשבונית',
        'invoice-notes-placeholder': 'הערות שיופיעו על החשבונית...',
        'invoice-line-items': 'שורות החשבונית',
        'description-of-services': 'תיאור השירותים',
        'description-of-services-placeholder': 'תארו את השירותים שסופקו...',
        'description-of-services-helper': 'תיאור השירותים שסופקו',
        'line-description': 'תיאור / פריט',
        'line-description-placeholder': 'תיאור שירות / פריט',
        'line-quantity': 'כמות',
        'line-unit-price': 'מחיר ליחידה',
        'line-vat': 'מע"מ',
        'line-total': 'סה"כ שורה',
        'vat-18': 'מע"מ 18%',
        'vat-0': 'מע"מ 0%',
        'vat-exempt': 'פטור ממע"מ',
        'add-line': '+ הוספת שורה',
        'subtotal-excl-vat': 'סה"כ לפני מע"מ',
        'vat-amount': 'מע"מ',
        'total-payable': 'סה"כ לתשלום',
        'invoice-request-submitted': 'הבקשה לחשבונית נשלחה בהצלחה.',

        'expense-request-page-subtitle': 'דיווח על הוצאה עסקית — ספק, קנייה, שירות או תשלום אחר',
        'submit-expense-request': 'שליחת בקשה להוצאה',
        'attach-receipt': 'צירוף קבלה',
        'attach-receipt-dropzone-title': 'לחצו לצירוף חשבונית / קבלה או גררו לכאן',
        'attach-receipt-dropzone-hint': 'חשוב: צרפו תמונה ברורה שממנה ניתן לראות את סוג ההוצאה, שם הספק והסכום · PDF, JPG, PNG עד 10MB',
        'receipt-is-required': 'חובה לצרף קבלה.',
        'supplier-service-provider': 'ספק / נותן שירות',
        'search-supplier-placeholder': 'חיפוש ספק לפי שם או מספר...',
        'no-suppliers-linked-to-you': 'אין ספקים המשויכים לחשבון שלך.',
        'expense-details': 'פרטי ההוצאה',
        'expense-description': 'תיאור ההוצאה',
        'expense-description-placeholder': 'לשם מה נדרש התשלום? (למשל: "הדרכה", "ציוד", "נסיעות")',
        'expense-description-helper': 'תארו את מטרת ההוצאה והקשר שלה לפעילות העסקית',
        'invoice-number-placeholder': 'INV-0001',
        'category': 'קטגוריה',
        'select-category': 'בחרו קטגוריה...',
        'expense-category-office-supplies': 'ציוד וחומרי משרד',
        'expense-category-travel-fuel': 'נסיעות ודלק',
        'expense-category-food-hospitality': 'אוכל ואירוח עסקי',
        'expense-category-software-subscriptions': 'תוכנות ומנויים',
        'expense-category-computer-electronics': 'מחשבים ואלקטרוניקה',
        'expense-category-advertising-marketing': 'פרסום ושיווק',
        'expense-category-professional-services': 'שירותים מקצועיים',
        'expense-category-training-education': 'הדרכות והשתלמויות',
        'expense-category-communications': 'תקשורת',
        'expense-category-office-rent-maintenance': 'שכירות ותחזוקת משרד',
        'expense-category-other': 'אחר',
        'total-amount-incl-vat': 'סכום כולל מע"מ',
        'total-amount-helper': 'הזינו את הסכום הכולל כפי שמופיע בקבלה',
        'includes-vat': 'מע"מ',
        'includes-vat-rate': 'כולל מע"מ {{rate}}%',
        'who-pays-for-the-expense': 'מי משלם על ההוצאה?',
        'bank-account-details-for-payment': 'פרטי חשבון בנק לתשלום',
        'account-holder-name': 'שם בעל החשבון',
        'account-holder-name-placeholder': 'שם מלא',
        'bank-name-placeholder': 'בחרו בנק...',
        'branch-number': 'מספר סניף',
        'branch-number-placeholder': '0000',
        'account-number': 'מספר חשבון',
        'account-number-placeholder': '000000',
        'paid-by-yeuls': 'יעול שכיר (החברה)',
        'paid-by-yeuls-hint': 'ההוצאה תנוכה מההכנסה בתלוש השכר, ללא מע"מ',
        'paid-by-me': 'אני (נותן השירות) — החזר הוצאות',
        'paid-by-me-hint': 'שילמתי מכיסי ומבקש החזר מהחברה',
        'expense-request-submitted': 'הבקשה להוצאה נשלחה בהצלחה.',

        'service-call-page-subtitle': 'לכל שאלה, בעיה או בקשה — אנחנו כאן בשבילכם',
        'open-support-ticket': 'פתיחת קריאת שירות',
        'ticket-details': 'פרטי הקריאה',
        'ticket-subject': 'נושא',
        'ticket-subject-placeholder': 'תיאור הבעיה או הבקשה בשורה אחת',
        'target-department': 'מחלקה מטפלת',
        'select-target-department': 'איזה צוות צריך לטפל בזה?',
        'department-it-computing': 'מחשוב ו-IT',
        'department-maintenance-operations': 'תחזוקה ותפעול',
        'department-hr-payroll': 'משאבי אנוש ושכר',
        'department-finance-accounting': 'כספים והנהלת חשבונות',
        'department-other': 'אחר',
        'ticket-description': 'תיאור מפורט',
        'ticket-description-placeholder': 'תארו את הבעיה, איך לשחזר אותה ומה כבר ניסיתם...',
        'attachments-optional': 'קבצים מצורפים (אופציונלי)',
        'attach-file-dropzone-title': 'לחצו להעלאת צילום מסך / קובץ או גררו לכאן',
        'attach-file-dropzone-hint': 'שימושי לתקלות מחשוב ובעיות תפעוליות · PDF, JPG, PNG עד 10MB',
        'support-ticket-submitted': 'קריאת השירות נפתחה בהצלחה.',

        'my-requests-title': 'הבקשות שלי',
        'my-requests-subtitle': 'עקבו אחרי כל הבקשות, החשבוניות וההוצאות שלכם',
        'all-requests-title': 'כל הבקשות',
        'all-requests-subtitle': 'עקבו אחרי כל הבקשות שנשלחו על ידי המשתמשים',
        'all-requests-tab': 'הכל',
        'invoice-requests-tab': 'חשבוניות',
        'expense-requests-tab': 'הוצאות',
        'service-calls-tab': 'שירות',
        'recurring-requests-tab': 'חוזרות',
        'recurring-invoices-tracking': 'חשבוניות חוזרות — מעקב חידוש חודשי',
        'recurring-status-renewing': 'מתחדשת',
        'renewal-history': 'היסטוריית חידוש',
        'recurring-schedule-day': 'יום {{day}} בכל חודש',
        'recurring-step-generated': 'הופקה',
        'recurring-step-in_progress': 'בטיפול',
        'recurring-step-pending': 'ממתין',
        'recurring-step-skipped': 'דולג',
        'recurring-step-next': 'הבא',
        'recurring-month-jan': 'ינו',
        'recurring-month-feb': 'פבר',
        'recurring-month-mar': 'מרץ',
        'recurring-month-apr': 'אפר',
        'recurring-month-may': 'מאי',
        'recurring-month-jun': 'יונ',
        'recurring-month-jul': 'יול',
        'recurring-month-aug': 'אוג',
        'recurring-month-sep': 'ספט',
        'recurring-month-oct': 'אוק',
        'recurring-month-nov': 'נוב',
        'recurring-month-dec': 'דצמ',
        'requests-stat-total': 'סה"כ',
        'requests-stat-pending': 'בהמתנה',
        'requests-stat-completed': 'הושלמו',
        'requests-stat-recurring': 'חוזרות',
        'search-requests-placeholder': 'חיפוש לפי תיאור, לקוח, ספק...',
        'all-statuses': 'כל הסטטוסים',
        'request-type-invoice': 'חשבונית',
        'request-type-expense': 'הוצאה',
        'request-type-service': 'שירות',
        'no-requests-yet': 'אין כאן בקשות עדיין.',
        'no-attachments': 'אין קבצים מצורפים.',
        'request-id': 'מספר בקשה',
        'request-view-close': 'סגור',
        'submitted-by': 'נשלח על ידי',
        'recurring-invoice': 'חוזרת',
        'expense-category': 'קטגוריה',
        'subject': 'נושא',
        'request-status-new': 'חדש',
        'request-status-in_progress': 'בטיפול',
        'request-status-done': 'הושלם',
        'request-status-rejected': 'נדחה',

        'features-title': 'מה תוכלו לראות ולעשות בפורטל?',
        'salary-slips-title': 'בקשות ושאלות',
        'salary-slips-description': 'טפסים מרוכזים לכל הפניות',
        'final-report-title': 'דוח ריכוז סופי',
        'final-report-description': 'תוכלו לצפות בדוח המציג בצורה ברורה מאין הגיעו כל ההכנסות לתלוש השכר שלכם',
        'our-services-title': 'השירותים שלנו כוללים',
        'financial-treatment-title': 'טיפול פיננסי מלא',
        'financial-treatment-description': 'אין צורך לפתוח תיק עצמאי במס הכנסה או בביטוח לאומי',
        'social-rights-title': 'זכויות סוציאליות',
        'social-rights-description': 'אפשרות לדמי אבטלה ולדמי לידה',
        'professional-consultation-title': 'ייעוץ מקצועי',
        'professional-consultation-description': 'ייעוץ פיננסי וביטוחי אישי ממומחים בתחום',
        'important-to-know-title': '?מה עוד חשוב לדעת',
        'managed-forms-title': 'טפסים מנוהלים',
        'managed-forms-description': 'כל הטפסים (כגון טופס 101) מנוהלים דרך הפורטל באופן אוטומטי',
        'tracking-updates-title': 'מעקב ועדכונים',
        'tracking-updates-description': 'תקבלו הודעות ועדכונים על סטטוס הפניות ישירות בפורטל',
        'video-guides-title': 'סרטוני הדרכה',
        'hebrew-video-title': 'סרטון תלוש משכורת (עברית)',
        'hebrew-video-description': '',
        'english-video-title': 'סרטון תלוש משכורת (אנגלית)',
        'english-video-description': '',
        'all-rights-reserved': 'כל הזכויות שמורות .Fincome |יעול שכיר ©',
        'personal-support-title': 'שירות אישי וזמין ',
        'personal-support-description': 'נטלי, מנהלת קשרי הצלחה שלנו, פה לשירותכם ותטפל בכל בעיה במידה ולא הסתדרתם במילוי הטפסים או בכל נושא אחר. אל תהססו לפנות',
        'copyright-text': '',
        'docs-title': 'צפייה במסמכים',
        'docs-description': 'כל החשבוניות, קבלות, תלושי שכר מרוכזים במקום אחד, נגישים להורדה בכל עת',
        'otp-has-been-sent': ".שלחנו קוד חד פעמי לכתובת האימייל שלך",
        'code-will-expire-in-5-mins': '.הקוד תקף לחמש דקות',
        'login-title': 'ברוכים הבאים לפורטל יעול שכיר | Fincome!',
        'login-subtitle': 'צפייה בתלושי שכר, הוצאות והכנסות, הגשת בקשות להחזרים והעלאת חשבוניות. אנחנו כאן לכל שאלה גם בפנייה ישירה דרך המערכת.',
        'login-footer-title': 'כל מה שצריך במקום אחד',
        from: 'מתאריך',
        to: 'עד תאריך',
        true: 'כן',
        false: 'לא',
        'email-tracking-report-title': 'דוח מעקב מיילים',
        'email-tracking-load-report': 'טען דוח',
        'email-tracking-range-label': 'טווח',
        'email-tracking-range': 'טווח: {{from}} - {{to}}',
        'email-tracking-email-title': 'מייל {{index}}',
        'email-tracking-no-data-for-email': 'אין נתונים זמינים עבור מייל זה.',
        'email-tracking-select-range-and-load': 'בחר טווח תאריכים ולחץ על טעינת דוח.',
        'email-tracking-select-from-to-dates': 'יש לבחור תאריך התחלה ותאריך סיום.',
        'email-tracking-invalid-range': 'תאריך ההתחלה חייב להיות קטן או שווה לתאריך הסיום.',
        'email-tracking-max-range-week': 'טווח התאריכים לא יכול להיות גדול מ-7 ימים.',
        'email-tracking-something-went-wrong': 'אירעה שגיאה. נסה שוב.',
        'email-tracking-no-emails-found': 'לא נמצאו מיילים בטווח התאריכים שנבחר.',
        'email-tracking-filter-unsent': 'מיילים שלא נשלחו',
        'email-tracking-col-email-date': 'תאריך',
        'email-tracking-col-sender-address': 'שם שולח',
        'email-tracking-col-file-number': 'מספר קובץ',
        'email-tracking-col-file-type': 'סוג קובץ',
        'email-tracking-col-user-no': 'מספר משתמש',
        'email-tracking-col-client-no': 'מספר לקוח',
        'email-tracking-col-user-email': 'אימייל משתמש',
        'email-tracking-col-client-email': 'אימייל לקוח',
        'email-tracking-col-sent-to-user': 'נשלח למשתמש',
        'email-tracking-col-reason-not-sent-to-user': 'סיבה למה לא נשלח למשתמש',
        'email-tracking-col-sent-to-client': 'נשלח ללקוח',
        'email-tracking-col-reason-not-sent-to-client': 'סיבה למה לא נשלח ללקוח',
        'email-tracking-reason-unknown-type': 'לא ניתן לזהות את סוג הקובץ',
        'email-tracking-reason-unknown-number': 'לא ניתן לחלץ מספר קובץ משם הקובץ',
        'email-tracking-reason-invoice-not-found': 'חשבונית לא נמצאה במסד הנתונים',
        'email-tracking-reason-receipt-not-found': 'קבלה לא נמצאה במסד הנתונים',
        'email-tracking-reason-user-not-found-invoice': 'לא נמצא משתמש עבור חשבונית זו',
        'email-tracking-reason-user-not-found-receipt': 'לא נמצא משתמש עבור קבלה זו',
        'email-tracking-reason-client-not-found-invoice': 'לא נמצא לקוח עבור חשבונית זו',
        'email-tracking-reason-client-not-found-receipt': 'לא נמצא לקוח עבור קבלה זו',
        'email-tracking-reason-user-email-missing': 'אימייל משתמש חסר',
        'email-tracking-reason-client-email-missing': 'אימייל לקוח חסר',
        'email-tracking-reason-unauthorized-sender': 'אימייל מאת שולח לא מורשה',
        'email-tracking-reason-no-attachments': 'אין קבצים מצורפים במייל',
        'email-tracking-reason-company-id-not-allowed': 'מזהה חברה אינו מורשה',
        'email-tracking-reason-email-mismatch': 'אי-התאמת אימייל בין מסדי הנתונים',
        'email-tracking-reason-storage-upload-failed': 'העלאת קובץ לאחסון נכשלה',
        'email-tracking-reason-document-update-failed': 'עדכון המסמך נכשל',
        'email-tracking-reason-email-send-failed': 'שליחת אימייל נכשלה',
        'email-tracking-reason-email-already-sent': 'האימייל כבר נשלח',
        'email-tracking-reason-internal-server-error': 'שגיאת שרת פנימית',
        'auth-history-report-title': 'היסטוריית התחברויות',
        'auth-history-load-report': 'טען דוח',
        'auth-history-range-label': 'טווח',
        'auth-history-select-from-to-dates': 'יש לבחור תאריך התחלה ותאריך סיום.',
        'auth-history-invalid-range': 'תאריך ההתחלה חייב להיות קטן או שווה לתאריך הסיום.',
        'auth-history-something-went-wrong': 'אירעה שגיאה. נסה שוב.',
        'auth-history-no-records-found': 'לא נמצאו התחברויות בטווח התאריכים שנבחר.',
        'auth-history-col-date': 'תאריך',
        'auth-history-col-device-type': 'מכשיר',
        'auth-history-col-user-name': 'שם',
        'auth-history-col-email': 'אימייל',
        'auth-history-col-identity-number': 'תעודת זהות',
        'auth-history-col-role': 'תפקיד',
        'auth-history-col-agent-id': 'מספר סוכן',
        'auth-history-last-login': 'התחברות אחרונה',
        'auth-history-logins-count': 'התחברויות',
        'sync-from-maskoreshet': 'סנכרון מ-Maskoreshet',
        'data-synced-from-maskoreshet': 'הנתונים סונכרנו מ-Maskoreshet בהצלחה'
      },
    },
  },
  lng: SessionStorageService.getAppLanguage(),
});
